import { createCachedAPI } from '../utils/api';

export const getNumberOfMatches = createCachedAPI<{
  incommingCvs: number;
  matches: number;
  matchedCvs: number;
}>(import.meta.env.VITE_API_MATCHES);
